const useIntervenients = (requisition) => {
	const surgeon =
		requisition?.surgicalRequestAdmission?.intervenients?.surgeon?.name
	const assistant =
		requisition?.surgicalRequestAdmission?.intervenients?.medicAssistant
			?.name
	const anesthesiologist =
		requisition?.surgicalRequestAdmission?.intervenients?.anesthesiologist
			?.name
	const instrumentalist =
		requisition?.surgicalRequestAdmission?.intervenients?.instrumentalist
			?.name
	const other =
		requisition?.surgicalRequestAdmission?.intervenients?.other?.name

	const hasSurgeon = !!(
		requisition?.surgicalRequestAdmission?.intervenients?.surgeon?.name &&
		requisition.surgicalRequestAdmission.intervenients.surgeon.name !== ''
	)

	const hasAssistant = !!(
		requisition?.surgicalRequestAdmission?.intervenients?.medicAssistant
			?.name &&
		requisition.surgicalRequestAdmission?.intervenients?.medicAssistant
			.name !== ''
	)

	const hasAnesthesiologist = !!(
		requisition?.surgicalRequestAdmission?.intervenients?.anesthesiologist
			?.name &&
		requisition.surgicalRequestAdmission.intervenients.anesthesiologist
			.name !== ''
	)

	const hasInstrumentalist = !!(
		requisition?.surgicalRequestAdmission?.intervenients?.instrumentalist
			?.name &&
		requisition.surgicalRequestAdmission.intervenients.instrumentalist
			.name !== ''
	)

	const hasOther = !!(
		requisition?.surgicalRequestAdmission?.intervenients?.other?.name &&
		requisition.surgicalRequestAdmission.intervenients.other.name !== ''
	)

	const hasIntervenient =
		hasSurgeon ||
		hasAssistant ||
		hasAnesthesiologist ||
		hasInstrumentalist ||
		hasOther

	return {
		surgeon,
		assistant,
		anesthesiologist,
		instrumentalist,
		other,
		hasSurgeon,
		hasAssistant,
		hasAnesthesiologist,
		hasInstrumentalist,
		hasOther,
		hasIntervenient,
	}
}

export default useIntervenients
